import { PrecifieldUsersResponse } from '../types/precifield-users';
import { TutorialsResponse } from '../types/tutorials';

import { handleRequest, privateClient } from '@data-access';

export const supportApi = {
  getTutorials: async () => {
    return handleRequest<TutorialsResponse>(
      privateClient.get('supports/').json(),
    );
  },
  getPrecifieldUsers: async () => {
    return handleRequest<PrecifieldUsersResponse>(
      privateClient.get('precifield_users/').json(),
    );
  },
  sendContactForm: async (data: { title: string; description: string }) => {
    return handleRequest<unknown>(
      privateClient.post('helpme/', {
        json: data,
      }),
    );
  },
};
